import React from 'react';
import { Link } from 'react-router-dom';

const Button = (props) => {

    return (
        <a href={`${props.link}`}>
            <div className='relative top-32 h-14 w-[200px] ml-6 rounded-full bg-red-500 font-sen'>
                <a className='relative top-[21%] left-[25%]'>{props.tekst}</a>
            </div>
        </a>
    );
}

export default Button;
